import { render, staticRenderFns } from "./listOwnerCarList.vue?vue&type=template&id=52d4962b&scoped=true"
import script from "./listOwnerCarList.vue?vue&type=script&lang=js"
export * from "./listOwnerCarList.vue?vue&type=script&lang=js"
import style0 from "./listOwnerCarList.vue?vue&type=style&index=0&id=52d4962b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52d4962b",
  null
  
)

export default component.exports